// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSpecialEmphasisDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SpecialEmphasisDTO from '../models/SpecialEmphasisDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    specialEmphasisId: number;
    specialEmphasis: SpecialEmphasisDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            specialEmphasisId: 0,
            specialEmphasis: null,
        },
        initValues);
    },
    specialEmphasisId: 'specialEmphasisId',
    specialEmphasis: 'specialEmphasis',
}

interface Result extends ResultDTO {
    specialEmphasis: SpecialEmphasisDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            specialEmphasis: null,
        },
        initValues);
    },
    specialEmphasis: 'specialEmphasis',
}

export { Request, Result };